import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { NonMedicalItemCreateSchema } from "@/routes/(pharma)/_layout/inventory/item/-data/model"
import { useState } from "react"
import { toast } from "./ui/use-toast"
import { NumericForm, numericStringDefault, stringToNumericString, normalizeNumericForm } from "@/utils/numeric_string"
import { pharmacyClient } from "@/connect"

export function AddNonMedical() {
  type NonMedicalItemCreateSchemaForm = NumericForm<NonMedicalItemCreateSchema>
  const [data, setData] = useState<NonMedicalItemCreateSchemaForm>({
    trade_name: "",
    unit: numericStringDefault(),
    unit_type: "",
    metadata: {
      manufacturer: "",
      owner: "",
      category: "",
      sub_category: "",
    },
    barcode: "",
    tax: numericStringDefault(0),
    pharmacy_code: "",
    hsn_code: "",
  })
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)

  return (
    <Dialog open={open}>
      <DialogTrigger asChild>
        <p className="underline text-xs text-right cursor-pointer" onClick={() => {
          setOpen(true)
        }}>Don't see what you are looking for?</p>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Create New Non Medical Item</DialogTitle>
          <DialogDescription>
            Create a new non medcial item by entering the following details.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="name" className="text-right">
              Trade Name
            </Label>
            <Input
              value={data.trade_name}
              onChange={(e) => setData({ ...data, trade_name: e.target.value })}
              className="col-span-3"
            />
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="username" className="text-right">
              Unit
            </Label>
            <Input
              type="number"
              value={data.unit.strValue}
              onChange={(e) => {
                stringToNumericString(e.target.value, (value) => {
                  setData({ ...data, unit: value })
                })
              }}
              className="col-span-3"
            />
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="username" className="text-right">
              Unit Type
            </Label>
            <Input
              value={data.unit_type}
              onChange={(e) => setData({ ...data, unit_type: e.target.value })}
              className="col-span-3"
            />
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="username" className="text-right">
              Manufacturer
            </Label>
            <Input
              value={data.metadata.manufacturer}
              onChange={(e) => setData({ ...data, metadata: { ...data.metadata, manufacturer: e.target.value } })}
              className="col-span-3"
            />
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="username" className="text-right">
              Owner
            </Label>
            <Input
              value={data.metadata.owner}
              onChange={(e) => setData({ ...data, metadata: { ...data.metadata, owner: e.target.value } })}
              className="col-span-3"
            />
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="username" className="text-right">
              Category
            </Label>
            <Input
              value={data.metadata.category}
              onChange={(e) => setData({ ...data, metadata: { ...data.metadata, category: e.target.value } })}
              className="col-span-3"
            />
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="username" className="text-right">
              Sub Category
            </Label>
            <Input
              value={data.metadata.sub_category}
              onChange={(e) => setData({ ...data, metadata: { ...data.metadata, sub_category: e.target.value } })}
              className="col-span-3"
            />
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="username" className="text-right">
              Barcode
            </Label>
            <Input
              value={data.barcode}
              onChange={(e) => setData({ ...data, barcode: e.target.value })}
              className="col-span-3"
            />
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="username" className="text-right">
              {
                localStorage.getItem("pharmacyMetadata") ? JSON.parse(localStorage.getItem("pharmacyMetadata") || "{}").countryCode === "IN" ? "GST%" : "VAT%" : "VAT%"
              }
            </Label>
            <Input
              value={data.tax.strValue}
              onChange={(e) => {
                stringToNumericString(e.target.value, (value) => {
                  setData({ ...data, tax: value })
                })
              }}
              type="number"
              className="col-span-3"
            />
          </div>
          {(localStorage.getItem("pharmacyMetadata") && JSON.parse(localStorage.getItem("pharmacyMetadata") || "{}").countryCode === "IN") && <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="username" className="text-right">
              HSN Code
            </Label>
            <Input
              value={data.hsn_code}
              onChange={(e) => {
                setData({ ...data, hsn_code: e.target.value })
              }}
              type="number"
              className="col-span-3"
            />
          </div>}
        </div>
        <DialogFooter>
          <Button type="submit" disabled={loading} onClick={async () => {
            try {
              setLoading(true)
              const finalData = normalizeNumericForm<NonMedicalItemCreateSchema>(data)
              await pharmacyClient.createNonMedicalMaster({
                tradeName: finalData.trade_name.toUpperCase(),
                barcode: finalData.barcode,
                unit: finalData.unit,
                unitType: finalData.unit_type.toUpperCase(),
                metadata: {
                  category: finalData.metadata.category.toUpperCase(),
                  subCategory: finalData.metadata.sub_category.toUpperCase(),
                  owner: finalData.metadata.owner.toUpperCase(),
                  manufacturer: finalData.metadata.manufacturer.toUpperCase(),
                },
                taxProfile: {
                  applicableTaxes: [{
                    componentCode: "CGST",
                    ratePercent: finalData.tax/2,
                    description: "Central Goods and Services Tax",
                  }, {
                    componentCode: "SGST",
                    ratePercent: finalData.tax/2,
                    description: "State Goods and Services Tax",
                  }, {
                    componentCode: "IGST",
                    ratePercent: finalData.tax,
                    description: "Integrated Goods and Services Tax",
                  }],
                  classificationCodes: localStorage.getItem("pharmacyMetadata") ? JSON.parse(localStorage.getItem("pharmacyMetadata") || "{}").countryCode === "IN" ? [{
                    type: "HSN",
                    description: "Harmonized System of Nomenclature",
                    code: finalData.hsn_code,
                    source: "USER",
                  }] : [] : [],
                }
              })
              setLoading(false)
              toast({
                title: "Success",
                variant: "success",
                description: "Non medical item created successfully",
                duration: 5000,
              })
              setOpen(false)
            } catch (error) {
              console.log(error)
              toast({
                title: "Error",
                variant: "destructive",
                description: "Failed to create non medical item",
                duration: 5000,
              })
              setLoading(false)
            }
          }}>{loading ? "Please Wait..." : "Save Changes"}</Button>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}


